/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterUserKind = (typeof FilterUserKind)[keyof typeof FilterUserKind];

export const FilterUserKind = {
  user: 'user',
} as const;
